import { InjectionToken } from '@angular/core';
import { NotificationModel } from 'src/app/notification/models/notification';
import { CustomizerRequest, CustomizerResponse } from './model';
import { BehaviorSubject, distinctUntilChanged, filter, map, ReplaySubject, } from 'rxjs';

export const CUSTOMIZER = new InjectionToken<CustomizerWorkerSubject<CustomizerRequest, CustomizerResponse>>('CUSTOMIZER');

type WorkerRequest = {
    id: string;
    baseUrl?: string;
    catalog?: string;
}
type WorkerResponse = {
    id: string;
    error?: NotificationModel;
}

export class CustomizerWorkerSubject<Request extends WorkerRequest, Response extends WorkerResponse> {
    private _response: BehaviorSubject<Response> = new BehaviorSubject<Response>({ id: '' } as Response);
    private loading: BehaviorSubject<{ [key: string]: boolean }> = new BehaviorSubject<{ [key: string]: boolean }>({});
    private worker: Worker;

    public loading$ = this.loading.asObservable()
    // (id: string) {
    //     return this.loading.pipe(map(a => a[id]));
    // }

    public response$ = this._response.pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) == JSON.stringify(curr)))
    // (id: string) {
    //     return this.response.pipe(filter(a => a.id == id));
    // }

    constructor(
        private notificationService: ReplaySubject<NotificationModel>,
        private _baseUrl: string,
        private _catalog: string
    ) {
        this.worker = new Worker(new URL('./customizer-advanced2.worker', import.meta.url));
        this.worker.onmessage = (message: MessageEvent<Response>) => {
            this.loading.next(Object.assign(this.loading.getValue(), { [message.data.id]: false }));
            if (message.data.error)
                this.notificationService.next(message.data.error);
            else
                this._response.next(message.data);
        }
        this.worker.onerror = (ev: ErrorEvent) => {
            console.error(ev)
            this.notificationService.next({
                title: ev.filename,
                text: ev.message,
                color: 'var(--error-color, white)',
                backgroundColor: 'var(--error-background-color, red)',
                position: 'top-mid'
            });
        };
    }
    response(): Response {
        return this._response.getValue();
    }
    postMessage(message: Request, options?: StructuredSerializeOptions): void {
        message.baseUrl = this._baseUrl;
        message.catalog = this._catalog;
        this.loading.next(Object.assign(this.loading.getValue(), { [message.id]: true }));
        this.worker.postMessage(message, options);
    }
}
